export const OG_IMAGE_URL =
  'https://storage.googleapis.com/hapstack/images/logo-og.png'
